import { render, staticRenderFns } from "./CarrierProductForm.vue?vue&type=template&id=8b5526ea&scoped=true&"
import script from "./CarrierProductForm.vue?vue&type=script&lang=ts&"
export * from "./CarrierProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./CarrierProductForm.vue?vue&type=style&index=0&id=8b5526ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5526ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
